import addError from '../../../../utils/error.jsx';

export function request(price) {
    return {
        type: 'LADDERS_CREATE_PRICE_REQUEST',
        price
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'LADDERS_CREATE_PRICE_ERROR',
        errors
    };
}

export function finish({prices}) {

    return (dispatch) => {
        dispatch({
            type: 'LADDERS_CREATE_PRICE_FINISH',
            prices
        });

        dispatch({
            type: 'LADDERS_GET_LIST_REQUEST'
        });
    };
}
